export const LOGO_SRC = "/assets/logo.png";

export default function Logo({ compact = false }) {
  return (
    <span className="inline-flex items-center" data-testid="brand-logo">
      <img
        src={LOGO_SRC}
        alt="RESTART PRO — Stavitelství jako umění"
        className={`${compact ? "h-10" : "h-12"} w-auto object-contain`}
      />
    </span>
  );
}
